import React, { useState, useEffect, memo } from 'react';
import { Box, Container, Typography} from '@mui/material';
import { db } from '../../components/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import PromoTickets from '../components/PromoTickets';
import TaskFeed from '../components/TaskFeed';

const Dashboard = () => {
  const [metrics, setMetrics] = useState({
    activePromos: 0,
    activeForecasts: 0, // Changed from activeChallenges
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        // While the promos are static, we take the quantity from const base in PromoTickets (6 elements)
        const activePromos = 5; // When you have real data, uncomment the query below and remove this line
        // const promosQuery = query(collection(db, 'promos'), where('status', '==', 'approved'), where('isForecast', '==', false));
        // const promosSnapshot = await getDocs(promosQuery);
        // const activePromos = promosSnapshot.size;

        const forecastsQuery = query(
          collection(db, 'promos'),
          where('status', '==', 'approved'),
          where('kind', '==', 'forecast')
        );
        const forecastsSnapshot = await getDocs(forecastsQuery);
        const activeForecasts = forecastsSnapshot.size;

        setMetrics({ activePromos, activeForecasts });
        setLoading(false);
      } catch (err) {
        console.error('Error fetching metrics:', err);
        setMetrics({ activePromos: 6, activeForecasts: 0 }); 
        setLoading(false);
      }
    };
    fetchMetrics();
  }, []);

  return (
    <Box sx={{ backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
      {/* TOP - stories */}
      <PromoTickets />

     {/* Metrics — минималистично, без рамок */}
<Container maxWidth="xl" sx={{ py: 1.5, px: { xs: 2, sm: 3, md: 4 } }}>
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'baseline',
      gap: { xs: 1.5, sm: 3, md: 4 },
      color: '#0f172a', // чёрный текст
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#0f172a' }}>
        Active Promos 
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 900, color: '#0f172a' }}>
        {loading ? '—' : metrics.activePromos}
      </Typography>
    </Box>

    {/* тонкий разделитель */}
    <Typography sx={{ color: '#0f172a', opacity: 0.25 }}>•</Typography>

    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#0f172a' }}>
        Active Forecasts
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 900, color: '#0f172a' }}>
        {loading ? '—' : metrics.activeForecasts}
      </Typography>
    </Box>
  </Box>
</Container>




      {/* The task feed is below */}
      <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <TaskFeed />
      </Container>
    </Box>
  );
};

export default memo(Dashboard);


 